import CURPError from './CURPError';
class RegisterCURPError extends CURPError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('RegisterCURPError', ...args);
    }
}
export default RegisterCURPError;
